/*
 * Copyright (c) 2021 EGT Digital - All rights reserved.
 *
 * File: Scroller.tsx
 *
 * Written by Yuliyan Milenkov <yuliyan.milenkov@egt-digital.com> on  05.07.22 9:54 am.
 * Last modified: 05.07.22 9:54 am.
 *
 * More information at: https://egt-digital.com/
 */
import React from 'react';

export const PrevScroller = ({ onClick }: { onClick?: () => void }) => (
    <div className="arrow-icon" onClick={onClick}>
        <svg className="icon" width="18px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 17" id="arrow">
            <g>
                <path
                    id="chevron"
                    d="M3.6.6,12,8.8,20.4.6a2.18,2.18,0,0,1,3,0,2.18,2.18,0,0,1,0,3h0l-9.8,9.8a2.18,2.18,0,0,1-3,0L.6,3.6a2.17,2.17,0,0,1,0-3h0a2.17,2.17,0,0,1,3,0Z"
                />
            </g>
        </svg>
    </div>
);

export const NextScroller = ({ onClick }: { onClick?: () => void }) => (
    <div className="arrow-icon" onClick={onClick}>
        <svg className="icon" width="18px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 17" id="arrow">
            <g>
                <path
                    id="chevron"
                    d="M3.6.6,12,8.8,20.4.6a2.18,2.18,0,0,1,3,0,2.18,2.18,0,0,1,0,3h0l-9.8,9.8a2.18,2.18,0,0,1-3,0L.6,3.6a2.17,2.17,0,0,1,0-3h0a2.17,2.17,0,0,1,3,0Z"
                />
            </g>
        </svg>
    </div>
);

const Scroller = ({ variant, onClick }: IScrollerProps) => {
    return (
        <div className={`egt_lobby_section_${variant === 'left' ? 'leftScroller' : 'rightScroller'}`}>
            {variant === 'left' && <PrevScroller onClick={onClick} />}
            {variant === 'right' && <NextScroller onClick={onClick} />}
        </div>
    );
};

interface IScrollerProps {
    variant: 'left' | 'right';
    onClick?: () => void;
}

export default Scroller;
